export default "__VITE_ASSET__DxPsdMwW__"